import { io } from "socket.io-client";
import { eventBus } from "./event_bus";

class SocketService {
  constructor() {
    this.socket = null;
  }

  connect() {
    if (this.socket) return;

    const url = window.SOCKETIO_URL;

    if (!url) return;

    this.socket = io(url, {
      transports: ["websocket"],
      withCredentials: true,
    });

    this.registerEvents();
  }

  registerEvents() {
    this.socket.on("connect", () => {
      eventBus.emit("socket:connected", {
        socketId: this.socket.id,
      });
    });

    // this.socket.on("disconnect", () => {
    //   console.log("Socket desconectado");
    //
    //   eventBus.emit("socket:disconnected");
    // });
    //
    this.socket.on("message", (message) => {
      eventBus.emit("chat:message", message);
    });
    //
    // this.socket.on("notification", (notification) => {
    //   eventBus.emit("notification:new", notification);
    // });
    //
    // this.socket.on("ticket_updated", (ticket) => {
    //   eventBus.emit("ticket:updated", ticket);
    // });
  }

  emit(eventName, payload) {
    if (!this.socket) return;

    this.socket.emit(eventName, payload);
  }

  joinRoom(roomId) {
    this.emit("join_room", roomId);
  }

  leaveRoom(roomId) {
    this.emit("leave_room", roomId);
  }
}

const socketService = new SocketService();

export { socketService };
